var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "28B52F3F-F4A3-4845-86D6-100FD103E7C2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Membership",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.0.3-Member-icheckin",
    transform: "translate(-28.000000, -508.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pop-up"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 277.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Input",
    transform: "translate(16.000000, 101.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone",
    transform: "translate(0.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IC_Phone",
    transform: "translate(12.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Boundingbox",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_phone_iphone_48px",
    transform: "translate(5.000000, 1.000000)",
    fill: "#DFE2E6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,0 L3,0 C1.62,0 0.5,1.12 0.5,2.5 L0.5,19.5 C0.5,20.88 1.62,22 3,22 L11,22 C12.38,22 13.5,20.88 13.5,19.5 L13.5,2.5 C13.5,1.12 12.38,0 11,0 Z M7,21 C6.17,21 5.5,20.33 5.5,19.5 C5.5,18.67 6.17,18 7,18 C7.83,18 8.5,18.67 8.5,19.5 C8.5,20.33 7.83,21 7,21 Z M11.5,17 L2.5,17 L2.5,3 L11.5,3 L11.5,17 Z",
    id: "Shape"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhone);
export default __webpack_public_path__ + "static/media/ic_phone.6df31fa8e8c7a752a7cf97b9b2e39a78.svg";
export { ForwardRef as ReactComponent };